
class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const cart = this.closest("cart-notification");
      const product = this.closest(".cart-notification-product");

      if (!cart) return;

      if (product) {
        product.classList.add("loading");

        const overlay = product.querySelector(".loading-overlay");
        if (overlay) overlay.classList.remove("hidden");
      }

      cart.updateQuantity(this.dataset.index, 0);
    });
  }
}

if (!customElements.get("cart-remove-button-2")) {
  customElements.define("cart-remove-button-2", CartRemoveButton2);
}

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.cartItemConatiner = document.getElementById(
      "cart-notification-product"
    );

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.refreshEmptyStateElements();

    this.cartNoteData = document.getElementById("cartNote");
    this.cartNote = document.getElementById("cart_note_drawer");
    this.actionOverlay = document.querySelector(
      ".cart_action_drawer_overlay"
    );

    if (this.notification) {
      this.notification.addEventListener("keyup", (event) => {
        if (event.code === "Escape") this.close();
      });
    }

    const closeButton = this.querySelector(
      'button[type="button"].cart-notification__close'
    );

    if (closeButton) {
      closeButton.addEventListener("click", this.close.bind(this));
    }

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, input) => {
      return total + (parseInt(input.value, 10) || 0);
    }, 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener(
      "change",
      this.debouncedOnChange.bind(this)
    );
  }

  refreshEmptyStateElements() {
    this.emptyCartItem = document.getElementById("min-cart-items");

    this.cartItemMessageShow = document.querySelector(
      ".empty__cart__item"
    );

    this.emptyCartButtonDisable = document.getElementById(
      "empty__cart__button"
    );

    this.cartAddSuccess = document.querySelector(
      ".item__success_message"
    );

    this.cartEmptyHead = document.querySelector(
      ".item__empty_message"
    );

    this.cartItemConatiner = document.getElementById(
      "cart-notification-product"
    );
  }

  onChange(event) {
    if (event.target.closest("select")) return;

    const index = event.target.dataset.index;

    if (!index) return;

    this.updateQuantity(
      index,
      event.target.value,
      document.activeElement?.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add("animate", "active");
    document.body.classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();

        if (typeof trapFocus === "function") {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.removeEventListener("click", this.onBodyClick);
    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    if (this.notification) {
      this.notification.classList.remove("active");
    }

    document.body.classList.remove("added__overlay");
    document.body.removeEventListener("click", this.onBodyClick);

    if (typeof removeTrapFocus === "function") {
      const cartButton = document.querySelector(
        ".header__actions_btn--cart"
      );

      if (cartButton) removeTrapFocus(cartButton);
    }
  }

  // Update the header cart badge using Shopify's actual cart data.
  async refreshCartIconBubble() {
    try {
      const response = await fetch(
        `${window.Shopify?.routes?.root || "/"}cart.js`,
        {
          method: "GET",
          credentials: "same-origin",
          cache: "no-store",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }
        }
      );

      if (!response.ok) {
        throw new Error(`Cart request failed: ${response.status}`);
      }

      const cart = await response.json();
      const itemCount = Number(cart.item_count) || 0;

      document.querySelectorAll("#cart-icon-bubble").forEach((bubble) => {
        let countBubble = bubble.querySelector(".cart-count-bubble");

        if (itemCount > 0) {
          if (!countBubble) {
            countBubble = document.createElement("div");
            countBubble.className = "cart-count-bubble";
            bubble.appendChild(countBubble);
          }

          countBubble.replaceChildren();

          if (itemCount < 100) {
            const visibleCount = document.createElement("span");
            visibleCount.setAttribute("aria-hidden", "true");
            visibleCount.textContent = String(itemCount);
            countBubble.appendChild(visibleCount);
          }

          const hiddenCount = document.createElement("span");
          hiddenCount.className = "visually-hidden";
          hiddenCount.textContent = `Cart items: ${itemCount}`;
          countBubble.appendChild(hiddenCount);
        } else if (countBubble) {
          countBubble.remove();
        }
      });

      this.currentItemCount = itemCount;

      document.dispatchEvent(
        new CustomEvent("cart:count-updated", {
          detail: { itemCount, cart }
        })
      );

      return cart;
    } catch (error) {
      console.error("Cart count refresh error:", error);
      return null;
    }
  }

  renderContents(parsedState) {
    if (!parsedState) return;

    if (parsedState.sections) {
      this.getSectionsToRender().forEach((section) => {
        const element = document.getElementById(section.id);
        const html = parsedState.sections[section.id];

        if (!element || !html) return;

        element.innerHTML = this.getSectionInnerHTML(html);
      });
    }

    this.refreshEmptyStateElements();

    if (typeof parsedState.item_count !== "undefined") {
      const isEmpty = Number(parsedState.item_count) === 0;

      if (this.emptyCartItem) {
        this.emptyCartItem.classList.toggle("no-js-inline", isEmpty);
      }

      if (this.emptyCartButtonDisable) {
        this.emptyCartButtonDisable.classList.toggle(
          "no-js-inline",
          isEmpty
        );
      }

      if (this.cartItemMessageShow) {
        this.cartItemMessageShow.classList.toggle(
          "no-js-inline",
          !isEmpty
        );
      }

      if (this.cartAddSuccess) {
        this.cartAddSuccess.classList.toggle(
          "no-js-inline",
          isEmpty
        );
      }

      if (this.cartEmptyHead) {
        this.cartEmptyHead.classList.toggle(
          "no-js-inline",
          !isEmpty
        );
      }
    }

    if (this.header && typeof this.header.reveal === "function") {
      this.header.reveal();
    }

    // Do not wait for a page reload to update the header badge.
    this.refreshCartIconBubble();

    this.open();
  }

  getSectionsToRender() {
    return [
      { id: "cart-notification-product" },
      { id: "cart-notification-subtotal" },
      { id: "cart-notification-count" },
      { id: "cart-notification-discount" }
    ];
  }

  async updateQuantity(line, quantity, name, variantId) {
    const lineNumber = Number(line);
    const newQuantity = Number(quantity);

    if (
      !Number.isInteger(lineNumber) ||
      lineNumber < 1 ||
      !Number.isFinite(newQuantity) ||
      newQuantity < 0
    ) {
      return;
    }

    const quantityElement = document.getElementById(
      `Quantity-${line}`
    );

    const product = quantityElement?.closest(
      ".cart-notification-product"
    );

    if (product) product.classList.add("loading");

    const body = JSON.stringify({
      line: lineNumber,
      quantity: newQuantity,
      sections: this.getSectionsToRender().map(
        (section) => section.id
      ),
      sections_url: window.location.pathname
    });

    try {
      const response = await fetch(routes.cart_change_url, {
        ...fetchConfig(),
        method: "POST",
        headers: {
          ...fetchConfig().headers,
          "Content-Type": "application/json"
        },
        body
      });

      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }

      const parsedState = await response.json();

      if (parsedState.errors) {
        throw new Error(
          typeof parsedState.errors === "string"
            ? parsedState.errors
            : "Unable to update cart."
        );
      }

      // Refresh drawer sections and the header count.
      this.renderContents(parsedState);

      const updatedItem = parsedState.items
        ? parsedState.items[lineNumber - 1]
        : undefined;

      let message = "";

      if (
        quantityElement &&
        updatedItem &&
        updatedItem.quantity !== newQuantity &&
        window.cartStrings?.quantityError
      ) {
        message = window.cartStrings.quantityError.replace(
          "[quantity]",
          updatedItem.quantity
        );
      }

      this.updateLiveRegions(line, message);

      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-notification",
          cartData: parsedState,
          variantId
        });
      }
    } catch (error) {
      console.error("Cart update error:", error);

      if (quantityElement) {
        quantityElement.value =
          quantityElement.getAttribute("value") || "1";
      }

      this.updateLiveRegions(
        line,
        window.cartStrings?.error ||
          "Unable to update cart. Please try again."
      );
    } finally {
      if (product) product.classList.remove("loading");

      // Confirm the latest count from Shopify after the request.
      await this.refreshCartIconBubble();
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(
      `Line-item-error-${line}`
    );

    if (!lineItemError) return;

    const errorText = lineItemError.querySelector(
      ".cart-item__error-text"
    );

    if (errorText) {
      errorText.textContent = message || "";
    }

    lineItemError.classList.toggle("d-none", !message);
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const parsedDocument = new DOMParser().parseFromString(
      html,
      "text/html"
    );

    const section = parsedDocument.querySelector(selector);

    return section
      ? section.innerHTML
      : parsedDocument.body.innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    if (
      this.notification &&
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get("cart-notification")) {
  customElements.define("cart-notification", CartNotification);
}

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.cartButton = this.querySelector("a");
    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    if (this.cartButton) {
      this.cartButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.onClickMiniCart();
      });
    }

    if (this.notification) {
      this.notification.addEventListener("keyup", (event) => {
        if (event.code === "Escape") this.miniCartClose();
      });
    }
  }

  onClickMiniCart() {
    if (!this.notification) return;

    this.notification.classList.add("animate", "active");
    document.body.classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();

        if (typeof trapFocus === "function") {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.removeEventListener(
      "click",
      this.onBodyClassRemove
    );

    document.body.addEventListener(
      "click",
      this.onBodyClassRemove
    );
  }

  miniCartClose() {
    if (this.notification) {
      this.notification.classList.remove("active");
    }

    document.body.classList.remove("added__overlay");

    document.body.removeEventListener(
      "click",
      this.onBodyClassRemove
    );
  }

  handleBodyClass(event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    if (
      !target.closest("cart-notification") &&
      !target.closest("open-minicart") &&
      !target.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}

if (!customElements.get("open-minicart")) {
  customElements.define("open-minicart", OpenMiniCart);
}
